require("./certifications.scss");

var $ = require("jquery");

$(function () {
    const loadComponents = () => {
        $("#certification_tiles").children().each(function () {
            const elm = $(this);
            $(elm.data("target")).prepend(elm);
        });
    };

    loadComponents();
});